import React from 'react';
import {useDispatch} from 'react-redux';
import {hooks} from 'lib.front';
import {urls} from 'src/config';
import {logOut, loadingModal, openMsg} from 'src/redux-app';
import { clientLog } from 'src/common/gqlClientes';
import gql from 'graphql-tag';

//QUERIES
const logOutQ = gql`
   {
      logOutCrm {
         msg
      }
   }
`;
export default function useLogOut() {
   const dispatch = useDispatch();
   function callbackProcesarData(data) {
      dispatch(logOut());
   }

   function callbackLoading(loading) {
      dispatch(loadingModal(loading));
   }

   function callbackError(error) {
      dispatch(openMsg(JSON.stringify(error)));
   }
   const [logOutCall] = hooks.useApolloLazyQ(
      logOutQ,
      {
         callbackProcesarData: callbackProcesarData,
         callbackLoading: callbackLoading,
         callbackError: callbackError
      },
      {
         client: clientLog
      }
   );
   return logOutCall;
}
